import { createApp } from 'vue'
import App from './App.vue'
import './style.css'
// @ts-ignore - vite-plugin-pwa 提供的虚拟模块
import { registerSW } from 'virtual:pwa-register'

// 只在生产环境启用 PWA
if (import.meta.env.PROD) {
  registerSW({
    onNeedRefresh() {
      console.log('新内容可用，请刷新页面')
      // 可以在这里添加UI提示，让用户知道有新版本可用
      if (confirm('发现新版本，是否立即刷新更新？')) {
        location.reload()
      }
    },
    onOfflineReady() {
      console.log('应用已准备好离线工作')
    },
    onRegistered(registration) {
      console.log('Service Worker 已注册:', registration)
    },
    onRegisterError(error) {
      console.error('Service Worker 注册失败:', error)
    }
  })
}

createApp(App).mount('#app')
